import { setLocal, getLocal, clearLocal } from '@shared/components/localStorage';
import { Api, ApiConfig } from '@api';

export default {
  name: 'auth',
  state: {
    loading: false,
    user: {
      permissions: undefined,
    },
    token: getLocal('TOKEN'),
  },
  reducers: {
    loginSuccess(state, payload) {
      return {
        ...state,
        token: payload,
      };
    },
    logoutSuccess(state, newState) {
      return {
        ...state,
        ...newState,
      };
    },
    updateUser(state, payload) {
      return {
        ...state,
        user: payload,
      };
    },
    loginLoading(state, payload) {
      return {
        ...state,
        loading: payload,
      };
    },
  },
  effects: () => ({
    async login(payload) {
      this.loginLoading(true);
      try {
        const response = await Api.request(ApiConfig.login, {
          username: payload.email,
          password: payload.password,
        });
        setLocal('TOKEN', response.access_token);
        this.loginSuccess({
          token: response.access_token,
        });
      } catch (e) {
        if (typeof e !== 'string') {
          return '登录失败，请稍后重试';
        }
        return e;
      } finally {
        this.loginLoading(false);
      }
    },
    async logout() {
      try {
        await Api.request(ApiConfig.logout);
        clearLocal('TOKEN');
        clearLocal('DEBUG_USER');
        clearLocal('PWD_ALERT');
        this.logoutSuccess({
          token: getLocal('TOKEN'),
          user: {},
        });
      } catch (e) {
        console.log(e);
      }
    },
    async getUser() {
      try {
        const response = await Api.request(ApiConfig.getUserInfo);
        setLocal('DEBUG_USER', JSON.stringify(response));
        this.updateUser(response);
        return response;
      } catch (e) {
        console.log(e);
        return e;
      }
    },
    async getUserAgreement(payload) {
      try {
        const response = await Api.request(ApiConfig.getUserAgreement, {
          account: payload,
        });
        setLocal('USER_AGREEMENT', JSON.stringify(response.agreement_id));
      } catch (e) {
        clearLocal('USER_AGREEMENT');
        console.log(e);
      }
    },
    async confirmNewAgreement(payload) {
      try {
        await Api.request(ApiConfig.confirmNewAgreement, {
          account: payload.email,
          password: payload.password,
          agree: true,
        });
      } catch (e) {
        if (typeof e !== 'string') {
          return '授权最新协议失败，请稍后重试';
        }
        return e;
      }
    },
  }),
};
